import bootstrapper from '../bootstrapper';

const updateFailedPayment = async (paymentId) => {
  const failedPaymentsUrl = `${window.location.origin}/${bootstrapper.locale}/failed_payments/${paymentId}`;
  const CSRFToken = document.querySelector('input[name="authenticity_token"]')?.value || document.querySelector("[name='csrf-token']")?.content;

  return fetch(failedPaymentsUrl, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json; charset=UTF-8',
      'X-CSRF-Token': CSRFToken,
    },
  });
};

export default updateFailedPayment;
